(function () {
  // Guard: two PDP main sections in one template would load this twice.
  if (window.PXUThemePdpTrackingLoaded) return;
  window.PXUThemePdpTrackingLoaded = true;

  var configEl = document.querySelector('[data-pdp-tracking-data]');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    if (window.console) console.error('[pdp-tracking] bad config JSON', e);
    return;
  }

  window.dataLayer = window.dataLayer || [];

  var VARIANT = config.ab_variant || 'main';
  var PRODUCT_ID = config.product_id;
  var PRODUCT_NAME = config.product_name;

  function push(event, params) {
    var payload = {
      event: event,
      ab_variant: VARIANT,
      product_id: PRODUCT_ID,
      product_name: PRODUCT_NAME
    };
    for (var key in params) {
      if (Object.prototype.hasOwnProperty.call(params, key)) payload[key] = params[key];
    }
    window.dataLayer.push(payload);
  }

  push('pdp_view');

  // Add to cart. The ajax cart calls preventDefault on the button click, so the
  // native submit fallback only runs when the ajax drawer/mini-cart is off.
  var cartTracked = false;

  document.addEventListener('ww:cart:added', function (e) {
    var item = (e && e.detail) || {};
    cartTracked = true;
    push('pdp_add_to_cart', {
      product_id: item.product_id || PRODUCT_ID,
      product_name: item.product_title || PRODUCT_NAME,
      variant_id: item.variant_id || null,
      quantity: item.quantity || 1,
      is_pdp_product: String(item.product_id || PRODUCT_ID) === String(PRODUCT_ID)
    });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('[data-product-form]') : null;
    if (!form || cartTracked) return;
    var formProductId = form.getAttribute('data-product-id');
    push('pdp_add_to_cart', {
      product_id: formProductId || PRODUCT_ID,
      product_name: PRODUCT_NAME,
      variant_id: null,
      quantity: 1,
      is_pdp_product: String(formProductId || PRODUCT_ID) === String(PRODUCT_ID)
    });
  });

  // Specs accordion. Capture phase, because the accordion handler stops
  // propagation; at capture time aria-expanded still holds the pre-click state.
  document.addEventListener('click', function (e) {
    var button = e.target.closest ? e.target.closest('button[aria-controls]') : null;
    if (!button) return;
    if (button.getAttribute('aria-controls').indexOf('panel-tech-specs-') !== 0) return;
    if (button.getAttribute('aria-expanded') !== 'false') return;
    push('pdp_specs_open');
  }, true);

  // Time on page, counted only while the tab is visible.
  var milestones = (config.engaged_time_milestones || []).slice().sort(function (a, b) {
    return a - b;
  });
  var nextMilestone = 0;
  var activeSeconds = 0;
  var exitTracked = false;

  var ticker = window.setInterval(function () {
    if (document.visibilityState === 'hidden') return;
    activeSeconds += 1;
    while (nextMilestone < milestones.length && activeSeconds >= milestones[nextMilestone]) {
      push('pdp_engaged_time', { seconds: milestones[nextMilestone] });
      nextMilestone += 1;
    }
  }, 1000);

  function trackExit() {
    if (exitTracked) return;
    exitTracked = true;
    window.clearInterval(ticker);
    push('pdp_time_on_page', { seconds: activeSeconds });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') trackExit();
  });
  window.addEventListener('pagehide', trackExit);
})();